module.exports = __webpack_public_path__ + "static/media/redeem_points.44eaccf1.png";